import {useEffect} from "react";
import {Header} from "./Header";
import {useNavigate} from "react-router-dom";
import {useAuth} from "../hooks/useAuth";

const AnnualReports = () => {
    const navigate = useNavigate();
    const {isAuthenticated} = useAuth();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        if (!isAuthenticated) {
            navigate("/login", {
                replace: true,
            });
        }
    }, []);

    const yearReports = [
        {
            id: "1",
            title: "Annual Report 2014-2015",
            url: "https://jogkulstorageuat.blob.core.windows.net/siteassets/annual-reports/joglekarkul-annual-report-2014-2015.pdf",
        },
        {
            id: "2",
            title: "Annual Report 2015-2016",
            url: "https://jogkulstorageuat.blob.core.windows.net/siteassets/annual-reports/joglekarkul-annual-report-2015-2016.pdf",
        },
        {
            id: "3",
            title: "Annual Report 2016-2017",
            url: "https://jogkulstorageuat.blob.core.windows.net/siteassets/annual-reports/joglekarkul-annual-report-2016-2017.pdf",
        },
        {
            id: "4",
            title: "Annual Report 2017-2018",
            url: "https://jogkulstorageuat.blob.core.windows.net/siteassets/annual-reports/joglekarkul-annual-report-2017-2018.pdf",
        },
        {
            id: "5",
            title: "Annual Report 2018-2019",
            url: "https://jogkulstorageuat.blob.core.windows.net/siteassets/annual-reports/joglekarkul-annual-report-2018-2019.pdf",
        },
        {
            id: "6",
            title: "Annual Report 2019-2020",
            url: "https://jogkulstorageuat.blob.core.windows.net/siteassets/annual-reports/joglekarkul-annual-report-2019-2020.pdf",
        },
        {
            id: "7",
            title: "Annual Report 2020-2021",
            url: "https://jogkulstorageuat.blob.core.windows.net/siteassets/annual-reports/joglekarkul-annual-report-2020-2021.pdf",
        },
        {
            id: "8",
            title: "Annual Report 2021-2022",
            url: "https://jogkulstorageuat.blob.core.windows.net/siteassets/annual-reports/joglekarkul-annual-report-2021-2022.pdf",
        },
        {
            id: "9",
            title: "Annual Report 2022-2023",
            url: "https://jogkulstorageuat.blob.core.windows.net/siteassets/annual-reports/joglekarkul-annual-report-2022-2023.pdf",
        },
        {
            id: "10",
            title: "Annual Report 2023-2024",
            url: "https://jogkulstorageuat.blob.core.windows.net/siteassets/annual-reports/joglekarkul-annual-report-2023-2024.pdf",
        },
    ];

    // Sort the reports in descending order by extracting the first year from the title
    const sortedReports = [...yearReports].sort((a, b) => {
        const yearA = parseInt(a.title.split(" ")[2].split("-")[0], 10);
        const yearB = parseInt(b.title.split(" ")[2].split("-")[0], 10);
        return yearB - yearA;
    });

    return (
        <div>
            <Header/>
            <div className="md:mt-28">
                <div className="max-w-xl mx-auto min-h-screen w-full">
                    <h1 className="text-center font-custom-bold text-4xl my-10">
                        Annual Reports :-
                    </h1>
                    <div className="flex flex-col items-center justify-center gap-5 px-6 py-2">
                        {sortedReports.map((data) => (
                            <div
                                key={data.id}
                                className="bg-[#ff7043] text-white py-1 px-3  h-16 w-full border rounded-lg"
                            >
                                <a href={data.url} target="_blank" rel="noreferrer">
                                    <h2 className="text-center font-bold text-2xl py-2">
                                        {data.title}
                                    </h2>
                                </a>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AnnualReports;
